// extracted by mini-css-extract-plugin
export default {"pagination_sec":"Pagination_pagination_sec__0M2dv","navbtn":"Pagination_navbtn__+RDG6","page_num":"Pagination_page_num__bltDU"};